const PNF = require('google-libphonenumber').PhoneNumberFormat
const gphone = require('google-libphonenumber').PhoneNumberUtil.getInstance()

const moment = require('moment')

const parsers = {
    phone: function (number) {
        if (!!number) {
            var tel = gphone.parseAndKeepRawInput(number, 'US')
            return gphone.format(tel, PNF.NATIONAL)
        }
    },

    date: function (date_string) {
        if (!!date_string) {
            return moment(date_string).format("MMMM Do, YYYY")
        } else {
            return null
        }
    },
    date_month: function (date_string) {
        if (!!date_string) {
            return moment(date_string).format("MMMM Do")
        } else {
            return null
        }
    },

    date_time: function (date_string) {
        if (!!date_string) {
            return moment(date_string).format("h:mm a")
        } else {
            return null
        }
    },
    date_from_now: function (date_string) {
        return moment(date_string).fromNow()
    },

    timestamp: (time_String) => {
        return moment(time_String).format("MMMM Do YYYY, h:mm:ss a")
    },

    timestamp_brief: (time_String) => {
        return moment(time_String).format("MMM D YY, H:mm")
    },

    time_from_date: (date) => {
        return moment(date).format('HH:mm')
    },

    time: (time_String) => {
        return moment(time_String, "HH:mm:ss").format("HH:mm")
    },

    titleCase: (str) => {
        return str.trim().toLowerCase().split(' ').map((word) => {
            return word.replace(word[0], word[0].toUpperCase())
        }).join(' ')
    }
}

export default parsers
